import { jsx as _jsx } from "react/jsx-runtime";
import { PhoneTypes } from '@luminate/luminate-ts-sdk';
import { Picker } from './Picker';
export const PhoneTypePicker = ({ label = 'Phone Type', ...props }) => {
    return _jsx(Picker, { label: label, items: PhoneTypes, ...props });
};
